<template>
    <div class="consent-group element-relative wrapper">
        <div
            v-if="isLabelEnabled"
            class="consent-group-badge flex flex-column flex-content-center"
        >
            <span
                v-bastards
                class="fs-21 fs-lh-26 text-paragraph text-bold text-center"
            >
                Powiadomimy Cię o najlepszych ofertach
            </span>
        </div>
        <div class="element-relative flex flex-column">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isLabelEnabled: {
            type: Boolean,
            required: false,
            default: true
        }
    }
}
</script>

<style lang="scss">
.consent-group {
    $badge-height: 100px;
    $badge-width: 360px;

    z-index: 3;

    &-badge {
        background-color: $color-secondary;
        width: $badge-width;
        height: $badge-height;
        box-shadow: 0px 1px 0px $color-border;
        position: absolute;
        padding: 0 35px;
        bottom: calc(100% + 1px);
        right: 0;
        z-index: 1;

        .is-ie & {
            display: block;
            padding-top: 21px;
        }

        &:after {
            content: '';
            @include size(20px);
            @include transform(rotate(45deg));
            background-color: $color-secondary;
            box-shadow: 1px 1px 0px $color-border;
            position: absolute;
            top: calc(100% - 10px);
        }

        > * {
            margin-bottom: 0;
        }
    }

    @media (max-width: $screen-page-large) {
        &-badge {
            right: $value-wrapper-padding-laptop;
            width: 300px;
        }
    }

    @media (max-width: $screen-tablet) {
        &-badge {
            display: none;
        }
    }
}
</style>
